import { useTheme } from '@emotion/react';
import React from 'react';

import { Flex, Name, Text } from '~/components/blocks';
import { BookmarkTag } from '~/components/partials/BookmarkTag';
import { ClinicsAppTag } from '~/components/partials/ClinicsAppTag';
import { MedixsTag } from '~/components/partials/MedixsTag';
import { BasePatientProfileFragment } from '~/graphql/generated/graphql';
import { useMedixsSetting } from '~/hooks/use-medixs-setting';
import { Label } from '~/utils/label';

import { DetailSkeleton } from './DetailSkeleton';

type Props = {
  patient?: BasePatientProfileFragment | null;
};

export const ProfileDetail = React.memo((props: Props) => {
  const { patient } = props;
  const theme = useTheme();
  const { enabledMedixs } = useMedixsSetting();

  const isBookmarked = !!patient?.bookmark;

  return !patient ? (
    <DetailSkeleton />
  ) : (
    <>
      <Flex flexDirection="row" alignItems="flex-end" paddingRight={theme.space.m}>
        <Text wordBreak="break-all">
          <Name
            familyName={patient.familyName || ''}
            givenName={patient.givenName || ''}
            phoneticFamilyName={patient.phoneticFamilyName || ''}
            phoneticGivenName={patient.phoneticGivenName || ''}
            size="l"
          />
        </Text>
        <Text lineHeight={theme.lineHeights.s} marginLeft={theme.space.m}>
          {Label.age(patient.birthDate)}（{Label.sex(patient.sex)}）
        </Text>
      </Flex>
      <Flex marginTop={theme.space.l} marginBottom={theme.space.m}>
        <ClinicsAppTag isAppPatient={true} active={patient.active} />
        {patient.active && (
          <Flex marginLeft={theme.space.s}>
            <BookmarkTag isBookmarked={isBookmarked} />
          </Flex>
        )}
        {enabledMedixs && (
          <Flex marginLeft={theme.space.s}>
            <MedixsTag isLinked={!!patient.medixsPatient} />
          </Flex>
        )}
      </Flex>
    </>
  );
});

ProfileDetail.displayName = 'ProfileDetail';
